var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import { createTaroMouseEvent } from '../_util/taroEvent';
const SwiperItem = (_a) => {
    var { className, itemId, children, onClick } = _a, rest = __rest(_a, ["className", "itemId", "children", "onClick"]);
    return (_jsx("div", Object.assign({ className: classNames('swiper-slide', className), onClick: reactEvent => {
            const taroEvent = createTaroMouseEvent('tap', reactEvent);
            onClick === null || onClick === void 0 ? void 0 : onClick(taroEvent);
        } }, rest, { children: children }), itemId));
};
export default SwiperItem;
